const cancelSubscriptionActions = {
  DO_CANCEL_SUBSCRIPTION: 'DO_CANCEL_SUBSCRIPTION',
  DO_CANCEL_SUBSCRIPTION_SUCCEEDED: 'DO_CANCEL_SUBSCRIPTION_SUCCEEDED',
  DO_CANCEL_SUBSCRIPTION_FAILED: 'DO_CANCEL_SUBSCRIPTION_FAILED',
  doCancelSubscription: (propertyHash) => ({
    type: cancelSubscriptionActions.DO_CANCEL_SUBSCRIPTION,
    payload: propertyHash,
  }),
  doCancelSubscriptionSucceeded: response => ({
    type: cancelSubscriptionActions.DO_CANCEL_SUBSCRIPTION_SUCCEEDED,
    payload: response,
  }),
  doCancelSubscriptionFailed: response => ({
    type: cancelSubscriptionActions.DO_CANCEL_SUBSCRIPTION_FAILED,
    payload: response,
  }),
}

export default cancelSubscriptionActions;


// WEBPACK FOOTER //
// ./src/redux/cancelSubscription/actions.js